export const PROJECT_MARKS = ['prio_1', 'prio_2', 'decent'] as const;

export type ProjectMark = typeof PROJECT_MARKS[number];

export const PROJECT_MARK_LABELS: Record<ProjectMark, string> = {
  prio_1: 'Prio 1',
  prio_2: 'Prio 2',
  decent: 'Decent'
};

export const PROJECT_MARK_COLORS: Record<ProjectMark, string> = {
  prio_1: 'bg-red-500 text-white border-red-600',
  prio_2: 'bg-orange-500 text-white border-orange-600',
  decent: 'bg-slate-400 text-white border-slate-500'
};

export const PROJECT_MARK_BADGE_COLORS: Record<ProjectMark, string> = {
  prio_1: 'bg-red-100 text-red-700 border-red-200 dark:bg-red-950/50 dark:text-red-300 dark:border-red-800',
  prio_2: 'bg-orange-100 text-orange-700 border-orange-200 dark:bg-orange-950/50 dark:text-orange-300 dark:border-orange-800',
  decent: 'bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-900/50 dark:text-slate-400 dark:border-slate-700'
};
